




















import { Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import DataprocessServices from '@/services/dataprocess';
import PageMixin from '@/mixins/page-mixin';
import { mixins } from 'vue-class-component';
@Component({
  components: {}
})
export default class ExecResult extends mixins(PageMixin) {
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;
  @Prop() processJobType!: number;
  @Prop() sourceId!: number;
  @Prop() sqlstr!: string;

  dpSrv = new DataprocessServices();

  datalist: any[] = [];
  metalist: any[] = [];
  @Watch('visible')
  async onVisibleChange() {
    if (!this.syncVisible) return false;
    this.initPage();
    this.getList();
  }

  async getList() {
    this.loading = true;
    this.datalist = [];
    this.metalist = [];
    let res: any = {};

    debugger
    // 加工任务类型 0-FlinkSQL 1-Python 2-Script 3-Doris
    if (this.processJobType == 0) {
      res = await this.dpSrv.excuteLocal(this.sqlstr);
    } else if (this.processJobType == 3) {
        let params = {
        sourceId: this.sourceId,
        tableName: '',
        sqlquery: this.sqlstr,
        variables: [],
        pageSize: this.limit,
        pageNo: this.page,
      };
      res = await this.dpSrv.excuteSql(params);
    }
  
    this.datalist = res.results;
    if (this.datalist) {
      this.metalist = Object.keys(this.datalist[0]);
    }
    
    this.total = res.totalCount;
    this.loading = false;
  }

  get xWidth() {
    if (this.metalist) {
       return 180 * this.metalist.length;
    }
  }

  bodyStyle = { backgroundColor: '#EEE' };
}
